<script setup lang="ts">
import {ref} from 'vue';
import {SvgIcon} from '../../svg.ts';

export type DiffFilterTreeNode = {
  id: string;
  name: string;
  children: DiffFilterTreeNode[];
  isVisible: boolean;
  isIndeterminate: boolean;
};
const props = withDefaults(defineProps<{
  item: DiffFilterTreeNode,
  startExpanded?: boolean;
}>(), {
  startExpanded: false,
});

const emit = defineEmits(['update:visible']);

const isExpanded = ref<boolean>(props.startExpanded);
function handleExpand() {
  isExpanded.value = !isExpanded.value;
}

function handleCheck() {
  emit('update:visible', props.item);
}

function forwardChildCheck(descendantItem: DiffFilterTreeNode) {
  emit('update:visible', descendantItem);
}

</script>

<template>
  <div class="tw:flex tw:flex-col tw:items-start">
    <div class="item tw:flex tw:items-center">
      <div class="tw:w-6">
        <span
          v-if="item.children.length > 0"
          class="expand-toggle tw:pointer"
          @click.stop="handleExpand()"
        >
          <svg-icon
            :name="isExpanded ? 'octicon-triangle-down' : 'octicon-triangle-right'"
            :size="14"
          />
        </span>
      </div>
      <div class="ui checkbox">
        <input
          type="checkbox"
          :checked="item.isVisible"
          :indeterminate="item.isIndeterminate"
          @click="handleCheck"
        >
        <label>{{ item.name }}</label>
      </div>
    </div>
    <div
      v-if="isExpanded"
      class="tw:ml-4"
    >
      <DiffFilterTreeItem
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        @update:visible="forwardChildCheck"
      />
    </div>
  </div>
</template>
